export const getExpertPhoto = (photo?: string): string => {
  if (!photo) return '';
  const file = photo.replace(/^.*\//, ''); // pega so o nome do arquivo
  return `${process.env.PUBLIC_URL}/especialistas/${file}`;
};
